import { memberId } from '@trello/session-cookie';

interface MembershipProps {
  idMember: string;
  memberType: string;
  deactivated: boolean;
  unconfirmed: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isWorkspaceAdmin = (org: any): boolean => {
  return Boolean(
    org
      ?.get('memberships')
      ?.find(
        (membership: MembershipProps) =>
          membership.idMember === memberId &&
          membership.memberType === 'admin' &&
          !membership.deactivated &&
          !membership.unconfirmed,
      ),
  );
};
